import React, { useState, useEffect, useRef, useCallback } from "react";
import { pb4y as api } from "../../../../../services/apis";
import { producaov2 as api2 } from "../../../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  SemanticTable,
  ContainerInputSearch,
  Input,
  DivButton,
  ContainerAlign
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";
import { Box } from "@material-ui/core";

const ListarUsuarios = (props) => {
  const [loading, setLoading] = useState(true);
  const [usuarios, setUsuarios] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const pagina = useRef(1);

  useEffect(() => {
    loadAuth();
    loadUsuarios();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadUsuarios = async () => {
    await api
      .get(`/admin/get-users?page=${pagina.current}`,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      })
      .then(async (res) => {
        let logs = { local: "PocketBook", texto: `listou os usuarios` };
        await api2.post("system_logs", { acao: JSON.stringify(logs) });
        setUsuarios(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os valores", err, "error");
        setLoading(false);
      });
  };

  const verifyEmail = (e) => {
    if (e == null || e == undefined) {
      return "sem email";
    }
    return e;
  };

  const verifyName = (e) => {
    if (e == null || e == undefined) {
      return "sem nome";
    }
    return e;
  };

  const modifyPage = (value) => {
    if (value == "anterior") {
      if (pagina <= 1) {
        return;
      }
      pagina.current = pagina.current - 1;
      loadUsuarios();
    }
    if (value == "proximo") {
      pagina.current = pagina.current + 1;
      loadUsuarios();
    }
  };
  const searchUsuario = async () => {
    setFilter(true);
    api.get(`searchUser?search=${search}`,{
      headers: {
        access_token: `voitto-token ${localStorage.getItem(
          'oauth_token'
        )}`
      }
    }).then((res) => {
      const array = usuarios;

      array.users = res.data;
      setUsuarios({ ...usuarios, users: [...array.users] });
    });
    setSearch("");
    setFilter(false);
  };

  const handleDeletUser = async (id) => {
    const deleteMotive = "Usuário deletado através do admin";
    swal({
      title: "Você tem certeza ?",
      text: "Ao excluir o usuário, peça ao mesmo que faça o logoff assim concretizando a exclusão da conta",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          api.delete(`user-delete/${id}?cancelReason=${deleteMotive}`).then(res => {
            swal("Usuário removido da base de dados", {
              icon: "success",
            });
          }).catch(err => swal("Opps! Ocoreu um erro", err, "error"))
        } else {
          swal("Usuário mantido na base de dados");
        }
      });


  }

  const handleKeyUp = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      searchUsuario();
    }
  };

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
        <AdminMenu />
        {/* <Box> */}
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Lista de Usuarios no PocketBook ({usuarios.count})</Title>
            <ContainerInputSearch>
              <Input
                type="text"
                placeholder="Pesquise pelo email ou nome"
                value={search}
                onKeyUp={e => handleKeyUp(e)}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Button onClick={searchUsuario}>Pesquisar</Button>
            </ContainerInputSearch>

            {usuarios.users.length > 0 && (
              <>
                <SemanticTable size="big" celled>
                  <SemanticTable.Header>
                    <SemanticTable.Row>
                      <SemanticTable.HeaderCell style={{ width: "5%" }}>
                        ID
                      </SemanticTable.HeaderCell>
                      <SemanticTable.HeaderCell style={{ width: "60%" }}>
                        Nome
                      </SemanticTable.HeaderCell>
                      <SemanticTable.HeaderCell style={{ width: "40%" }}>
                        Email
                      </SemanticTable.HeaderCell>
                      <SemanticTable.HeaderCell style={{ width: "5%" }}>
                        Opções
                      </SemanticTable.HeaderCell>
                    </SemanticTable.Row>
                  </SemanticTable.Header>
                  <SemanticTable.Body>
                    {usuarios.users
                      .filter(
                        (valor) =>
                          verifyEmail(valor.email)
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                          verifyName(valor.name)
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                          filter == true
                      )
                      .map((valor, index) => (
                        <SemanticTable.Row>
                          <SemanticTable.Cell>{valor.id}</SemanticTable.Cell>
                          <SemanticTable.Cell>{valor.name}</SemanticTable.Cell>
                          <SemanticTable.Cell>{valor.email}</SemanticTable.Cell>
                          <SemanticTable.Cell>
                            <ContainerAlign>
                              <Button
                                icon="edit icon"
                                size="small"
                                color={"blue"}
                                onClick={() =>
                                  window.open(
                                    `/admin/blog/pocketbook4you/usuarios/detalhes/${valor.id}`
                                  )
                                }
                              />
                              <Button
                                icon="delete icon"
                                size="small"
                                color={"red"}
                                title="Remover usuário da base"
                                onClick={() => handleDeletUser(valor.id)}
                              />
                            </ContainerAlign>
                          </SemanticTable.Cell>
                        </SemanticTable.Row>
                      ))}
                  </SemanticTable.Body>

                </SemanticTable>
                <DivButton>
                  <Button
                    color="secondary"
                    icon
                    labelPosition="left"
                    floated="left"
                    content=""
                    onClick={() => modifyPage("anterior")}
                  >
                    <Icon name="angle double left" />
                    Anterior
                  </Button>
                  <Button
                    color="secondary"
                    icon
                    labelPosition="right"
                    floated="right"
                    onClick={() => modifyPage("proximo")}
                  >
                    <Icon name="angle double right" />
                    Proxima
                  </Button>
                </DivButton>
              </>
            )}
            {usuarios.users.length <= 0 && (

              <ContainerAlign>
                <h3>Nenhum Aluno encontrado</h3>
              </ContainerAlign>
            )
            }
          </Content>
        )}
        ;
      </Box>
      </Box>
  );
};

export default withRouter(ListarUsuarios);
